import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { createHead } from "@vueuse/head";

// 异步加载样式，避免阻塞首屏渲染
Promise.all([
  import("./assets/scss/main.scss"),
  import("./directives/vScrollAnimate"),
]).then(([, directiveModule]) => {
  const app = createApp(App);
  const head = createHead();

  app.use(store);
  app.use(router);
  app.use(head);

  if (directiveModule.vScrollAnimate) {
    app.directive("scroll-animate", directiveModule.vScrollAnimate);
  }

  app.mount("#app");
});
